<template>
  <v-content>
    <router-view></router-view>
  </v-content>
</template>
<script>
export default {
  name: "Content"
};
</script>
